import React, { type ReactNode, useContext, useMemo } from 'react';

import {
	RelayEnvironmentProvider as DefaultProvider,
	type IEnvironmentProvider,
	ReactRelayContext,
	useRelayEnvironment,
} from 'react-relay';

import { __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ } from './environment';

export function AtlassianRelayEnvironmentProvider({
	children,
}: {
	children: ReactNode;
}): React.JSX.Element {
	return (
		<DefaultProvider environment={__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__}>
			{children}
		</DefaultProvider>
	);
}

export const RelayEnvironmentProvider = AtlassianRelayEnvironmentProvider;

export const ConditionalRelayEnvironmentProvider = ({ children }: { children: ReactNode }) => {
	const isRelayPresent = useContext(ReactRelayContext);

	if (isRelayPresent) {
		return children;
	}

	return <AtlassianRelayEnvironmentProvider>{children}</AtlassianRelayEnvironmentProvider>;
};

export function useRelayEnvironmentProvider(): IEnvironmentProvider<{}> {
	const environment = useRelayEnvironment();

	return useMemo(
		() => ({
			getEnvironment() {
				return environment;
			},
		}),
		[environment],
	);
}
